<template>
  <button
    type="button"
    class="portal-analytics-card__download-btn"
    :disabled="!exportType || downloading"
    @click="onDownload"
  >
    {{ $t("portalHome.analytics.downloadXls") }}
  </button>
</template>

<script setup>
import { defineProps, ref } from "vue";
import { PortalAnalyticsService } from "@/services/portal-analytics.service";

const props = defineProps({
  exportType: { type: String, required: true },
});

const downloading = ref(false);

const onDownload = async () => {
  if (!props.exportType || downloading.value) {
    return;
  }

  downloading.value = true;

  try {
    await PortalAnalyticsService.downloadExcel(props.exportType);
  } catch (error) {
    console.warn("Failed to download portal analytics excel", error);
  } finally {
    downloading.value = false;
  }
};
</script>
